import { OnInit, Output, EventEmitter, ViewChild, AfterViewInit, Input, OnDestroy, ElementRef, Component } from "@angular/core";
import { Subscription, fromEvent, Observable } from "rxjs";
import {
    debounceTime,
    distinctUntilChanged,
    map,
    pluck,
    tap,
  } from "rxjs/operators";
  import {  IncidentCategoryDto, IncidentSubCategoryDto,  IncidentDto, QuantumDto, FacilityAssetDto, CleanUpStatusDto, UomDto } from '@cradua/data';
import { FormBuilder, FormGroup } from "@angular/forms";

  @Component({
    selector: 'cradua-incidentsearch',
    templateUrl: './incidentsearch.component.html',
    styleUrls: ['./incidentsearch.component.scss'],
  })
export class IncidentSearchComponent implements OnInit, AfterViewInit, OnDestroy{
    // @Input() incidentcategorys: IncidentCategoryDto[];
    // @Input() incidentsubcategorys: IncidentSubCategoryDto[];
   // @Input() incident: IncidentDto[];
    @Input() task: string;
    @Output() searchEmit = new EventEmitter<any>();
    @Output() emitEvent = new EventEmitter<any>();
    @Output() emitTask = new EventEmitter<any>();
    @Output() emitList = new EventEmitter<any>();
    @Output() emitIncidentType = new EventEmitter<any>();

    @ViewChild("search", {static: true})
    searchForm: ElementRef;
   searchSubscription$: Subscription;
   isFilter = false;
   isOpen:boolean;
   spillForm: FormGroup;
   incidentType = '';
    constructor(
      private fb: FormBuilder,
    ){}

    ngOnInit(): void {
      this.createSpillForm();
    }

    ngAfterViewInit(): void {

        this.searchSubscription$ = fromEvent(this.searchForm.nativeElement, "keyup")
          .pipe(
            debounceTime(500),
            distinctUntilChanged(),
            pluck("target", "value"),
            tap(_ => this.task === 'list' ? null : this.emitTask.emit('list')),
            // filter((searchTerm: string) => searchTerm.length > 2),
            map((value) => value),
          )
          .subscribe((data) => {
            this.searchEmit.emit(data)
          });

      }

      createSpillForm() {
        this.spillForm = this.fb.group({
          IncidentTypeStatus: [''],
        })
      }

      onChangeNotificationNoGenerator(event: string) {

        if(event === 'OilSpill') {
          this.spillForm.patchValue({IncidentTypeStatus: 'OilSpill'});
          this.incidentType = 'OilSpill';
          this.emitIncidentType.emit('OilSpill');
        } else {
            this.spillForm.patchValue({IncidentTypeStatus: 'NonOilSpill'});
            this.incidentType = 'NonOilSpill';
            this.emitIncidentType.emit('NonOilSpill');
          }
        }

      onViewAll(event) {
        if(event) {
          this.searchEmit.emit('fetchAll');
          this.emitTask.emit('list')
        } else {
          this.searchEmit.emit('');
          this.emitTask.emit('list')
        }
      }

    onFilter() {
      this.isFilter = !this.isFilter;
    }

    createEvent(){
        this.emitTask.emit('create')
    }

    viewListEvent(){
      this.emitList.emit('list')
    }

    ngOnDestroy(): void {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        if (this.searchSubscription$) {
          this.searchSubscription$.unsubscribe();
        }
      }
}
